import React from 'react';

export default function EmptyData({ text }) {
  return <div className="cabinet-nothing-found">{text ?? 'На жаль нічого не знайдено'}</div>;
}
